import { render } from "./Contacts.vue?vue&type=template&id=2e44c4cc&scoped=true"
import script from "./Contacts.vue?vue&type=script&lang=js"
export * from "./Contacts.vue?vue&type=script&lang=js"

import "./Contacts.vue?vue&type=style&index=0&id=2e44c4cc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2e44c4cc"

export default script